module.exports = __webpack_public_path__ + "img/jonathan-larson.1021e43b.png";